import {HttpClient} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {BehaviorSubject} from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';
import { Role, Usuario } from '../model/cadastros/usuario.model';
import { UnidadeInspecao } from '../model/cadastros/unidade-inspecao';
import {UsuarioDTO} from '../dto/sigevs/registration/usuario-dto.model';

export type Portal =
    | 'admin'
    | 'laboratorio'
    | 'mapa'
    | 'rt'
    | 'sve'
    | 'cidadao';

export type RolePortalMapping = {
    [key in Portal]: ReadonlyArray<Role>;
};

@Injectable({
    providedIn: 'root'
})
export class LoginService {
    private isAuthenticatedSubject = new BehaviorSubject<boolean>(false);
    public isAuthenticated$ = this.isAuthenticatedSubject.asObservable();
    private static readonly USER_INFO_KEY = 'usersession';

    constructor(
        private http: HttpClient,
        private router: Router,
        public oidcSecurityService: OAuthService,
    ) {
        window.addEventListener('storage', (e: StorageEvent) => {
            if (e.key === LoginService.USER_INFO_KEY && e.newValue === 'null') {
                this.logout();
            }
        });
    }

    init() {
        this.oidcSecurityService.loadDiscoveryDocumentAndLogin().then(isLoggedIn => {
            if (isLoggedIn) {
                this.isAuthenticatedSubject.next(true);
                this.oidcSecurityService.setupAutomaticSilentRefresh();
            } else {
                this.isAuthenticatedSubject.next(false);
            }
        });
    }

    login() {
        this.keycloakLoginSSO();
    }

    logout(noRedirectToLogoutUrl: boolean = false) {
        this.clear();
        this.oidcSecurityService.logOut(noRedirectToLogoutUrl);
    }

    /*logout2() {
        const postLogoutRedirectUri = window.location.origin + '/';
        const logoutUrl = environment.keycloak.logOutPdsa;

        const form = document.createElement('form');
        form.method = 'POST';
        form.action = logoutUrl;

        const redirectInput = document.createElement('input');
        redirectInput.type = 'hidden';
        redirectInput.name = 'post_logout_redirect_uri';
        redirectInput.value = postLogoutRedirectUri;
        form.appendChild(redirectInput);

        document.body.appendChild(form);
        form.submit();

        this.clear();
        sessionStorage.clear();
        setTimeout(() => this.oidcSecurityService.logOut(), 1500);
    }*/

    usuarioLogado(): boolean {
        return this.oidcSecurityService.hasValidAccessToken();
    }

    getUser(): Usuario | null {
        return JSON.parse(localStorage.getItem(LoginService.USER_INFO_KEY));
    }

    setUsuarioLogado(usuario: Usuario): void {
        // usuario.login = usuario.permissoes?.[0] ?? 'guest';
        localStorage.setItem(LoginService.USER_INFO_KEY, JSON.stringify(usuario));
    }

    redirectLogin(url) {
        this.router.navigate([url]);
    }

    redirectToHome() {
        this.router.navigate(['home']).then();
    }
    redirectTo(url: string) {
        this.router.navigate([url]).then();
    }

    doAuth() {
        return this.http.get<Usuario>(environment.urls.sigevs + '/auth/me', {
            headers: {'Authorization': 'Bearer ' + this.oidcSecurityService.getAccessToken()}
        });
    }

    clear() {
        localStorage.setItem(LoginService.USER_INFO_KEY, null);
    }

    keycloakLoginSSO() {
        if (!window.location.href.includes('state')) {
            this.oidcSecurityService.initLoginFlow();
        }
    }

    keycloackgetToken() {
        return this.oidcSecurityService.getAccessToken();
    }

    keycloackRefreshToken() {
        return this.oidcSecurityService.refreshToken();
    }
}
